import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Row,
  Table,
} from "antd";
import moment from "moment";

import productApi from "../../../../apis/Product.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../../layout/ContentHeaderComponent";

import BrandExcelUpload from "./BrandExcelUpload";

const BrandComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));
  const user = useSelector((state) => state.auth.user);

  const [mediaResult, setMediaResult] = useState(null);
  const [searchOptions, setSearchOptions] = useState({
    name: "",
    phone: "",
  });
  const [brandList, setBrandList] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalSize, setTotalSize] = useState(0);
  const [orderBy, setOrderBy] = useState("desc");
  const [orderType, setOrderType] = useState("id");

  const [brandModalShow, setBrandModalShow] = useState(false);
  const [sellerList, setSellerList] = useState([]);

  const columns = [
    {
      title: "브랜드 아이디",
      // width: 110,
      dataIndex: "id",
      key: "id",
      ellipsis: true,
      fixed: "left",
      sorter: (a, b) => {},
    },
    {
      title: "브랜드명",
      // width: 120,
      dataIndex: "brand_name",
      key: "brand_name",
      fixed: "left",
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value === "") {
          return <span>-</span>;
        } else {
          return value;
        }
      },
    },
    {
      title: "판매자명",
      // width: 120,
      dataIndex: "seller_name",
      key: "seller_name",
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value === "") {
          return <span>-</span>;
        } else {
          return value;
        }
      },
    },
    {
      title: "연락처",
      dataIndex: "phone",
      key: "phone",
      ellipsis: true,
    },
    {
      title: "사업자번호",
      // width: 120,
      dataIndex: "business_number",
      key: "business_number",
      ellipsis: true,
    },
    {
      title: "영업소재지",
      // width: 120,
      dataIndex: "business_location",
      key: "business_location",
      // ellipsis: true,
    },
    {
      title: "이메일",
      // width: 120,
      dataIndex: "email",
      key: "email",
      ellipsis: true,
      render: (value) => {
        if (value) {
          return value;
        } else {
          return "-";
        }
      },
    },
    {
      title: "기본배송비",
      // width: 120,
      dataIndex: "delivery_price",
      key: "delivery_price",
      ellipsis: true,
      align: "right",
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return value.toLocaleString() + "원";
        } else {
          return "-";
        }
      },
    },
    {
      title: "무료배송기준",
      // width: 120,
      dataIndex: "delivery_price_baseline",
      key: "delivery_price_baseline",
      ellipsis: true,
      align: "right",
      sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return value.toLocaleString() + "원";
        } else {
          return "-";
        }
      },
    },
    {
      title: "등록일",
      // width: 160,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
  ];

  const orderPair = {
    id: "브랜드아이디순",
    brand_name: "브랜드순",
    seller_name: "판매자순",
    delivery_price: "배송비순",
    delivery_price_baseline: "무료배송기준순",
    created_at: "등록일순",
  };

  /**
   * 모바일 처리 mobile -> true
   */
  useEffect(() => {
    if (typeof window !== "undefined") {
      const matchQueryList = window.matchMedia("all and (max-width: 768px)");
      setMediaResult(matchQueryList.matches);

      const media = function handleChange(e) {
        setMediaResult(e.matches);
      };

      matchQueryList.addEventListener("change", media);
    }
    readSellerList();
  }, []);

  useEffect(() => {
    readBrandList();
  }, [offset, pageSize, orderType, orderBy]);

  /**
   * 판매자 전체 목록 조회
   * @returns {Promise<void>}
   */
  const readSellerList = async () => {
    setIsLoading(true);
    try {
      const param = {
        userId: user.id === 724 ? 1 : user.id,
      };
      const res = await productApi.readSellerList(param);
      if (res.code === 200) {
        let sellerListByRes = res.result
          ?.filter((seller) => seller?.seller_id !== 24)
          .sort((seller1, seller2) => seller1.seller_id - seller2.seller_id);
        setSellerList(sellerListByRes);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("readSellerList read error", error);
    }
  };

  /**
   * 브랜드 목록 검색
   * @param type
   * @returns {Promise<void>}
   */
  const readBrandList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await productApi.readBrandListForSearch({
          name: "",
          phone: "",
          orderType: "id",
          orderBy: "desc",
          offset: 0,
          pageSize: 10,
          userId: user.id === 724 ? 1 : user.id,
        });
      } else if (type === "search") {
        res = await productApi.readBrandListForSearch({
          ...searchOptions,
          orderType,
          orderBy,
          offset: 0,
          pageSize: 10,
          userId: user.id === 724 ? 1 : user.id,
        });
      } else {
        res = await productApi.readBrandListForSearch({
          ...searchOptions,
          orderType,
          orderBy,
          offset,
          pageSize,
          userId: user.id === 724 ? 1 : user.id,
        });
      }
      if (res.code === 200) {
        setBrandList(res.result.brandList);
        setTotalSize(res.result.totalCnt);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alert(
          "브랜드 목록을 조회하는데 오류가 발생했습니다.\n다시 시도하시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
    } catch (error) {
      setIsLoading(false);
      console.log("readBrandList read error", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const reg = /^[0-9]*$/;
      if (value === "" || reg.test(value)) {
        setSearchOptions({ ...searchOptions, [name]: value });
      }
    } else {
      setSearchOptions({ ...searchOptions, [name]: value });
    }
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("id");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset(0);
    setCurrentPageNumber(1);
  };

  /**
   * 검색 버튼
   */
  const handleSearchBtnClick = async () => {
    if (searchOptions.category1 !== "" && searchOptions.category2 === "") {
      window.alert(
        "카테고리를 중분류까지 선택하거나 초기화한 뒤에 다시 검색해주시길 바랍니다.",
      );
    } else {
      setOffset(0);
      setCurrentPageNumber(1);
      readBrandList("search");
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      name: "",
      phone: "",
    });
    setOffset(0);
    setCurrentPageNumber(1);
    setOrderType("id");
    setOrderBy("desc");
    readBrandList("initial");
  };

  return (
    <>
      <ContentHeaderComponent title="브랜드 조회" />
      <div className="product-register-wrap">
        {/*브랜드검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            className="center-label"
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" gutter={[0, { xs: 8, md: 0 }]}>
              <label
                className="product-search-box-input-label"
                style={{ width: 110 }}
              >
                브랜드/판매자명
              </label>
              <Input
                className="product-search-box-input-wrap"
                name="name"
                value={searchOptions.name}
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
              <label
                className="product-search-box-input-label"
                style={{ width: mediaResult ? 110 : 70 }}
              >
                연락처
              </label>
              <Input
                className="product-search-box-input-wrap"
                name="phone"
                value={searchOptions.phone}
                placeholder="-를 제외하고 입력해주세요"
                onChange={handleChange}
                onPressEnter={handleSearchBtnClick}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearchBtnClick}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*상품목록*/}
        <Row
          className="product-register-border-box"
          wrap={false}
          justify={"space-between"}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              상품목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          <Button
            style={{
              fontSize: "0.9em",
            }}
            onClick={() => setBrandModalShow(true)}
          >
            <img
              style={{ height: 14.2, width: 14.5, marginRight: 5 }}
              src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
            />
            브랜드/판매자 추가
          </Button>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{ padding: "20px 25px 40px", height: "fit-content" }}
        >
          <Table
            columns={columns}
            dataSource={brandList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            // scroll={{ x: "calc(700px + 50%)" }}
            scroll={{ x: "max-content" }}
            tableLayout={"auto"}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>

      {brandModalShow && (
        <Modal
          className="excel-delivery-modal"
          title="브랜드/판매자 추가"
          visible={brandModalShow}
          onCancel={() => setBrandModalShow(false)}
          footer={null}
          width={700}
          style={{ top: 50 }}
        >
          <BrandExcelUpload
            setBrandModalShow={setBrandModalShow}
            handleInitialBtnClick={handleInitialBtnClick}
            sellerList={sellerList}
          />
        </Modal>
      )}
    </>
  );
};

export default BrandComponent;
